// Family Search Intent Pages (Tier 7)
const pages = [
  {
    slug: '/recovery-housing-for-my-son/',
    category: 'Family Search Intent', tier: 'Tier 7', gender: 'men',
    name: 'Recovery Housing for My Son',
    primaryKeyword: 'Recovery Housing for My Son',
    keywords: ['sober living for my son', 'recovery home for my son', 'help my son find sober living'],
    title: 'Recovery Housing for My Son | PGSRH Lehigh Valley, PA',
    description: 'Searching for recovery housing for your son? PGSRH offers structured, sober men’s home in Whitehall, PA. Compassionate help for families. Contact us.',
    blurb: 'For parents and families searching on behalf of a son.',
    heroSubtitle: 'If you’re searching for a safe place for your son, we understand — and we’re here to help you find structured men’s recovery housing.',
    intro: [
      'When a parent searches for “recovery housing for my son,” it usually comes after a lot of worry and a lot of love. PGSRH provides structured, sober men’s recovery housing in the Lehigh Valley, and we’re glad to help you understand the options.',
      'Our men’s home in Whitehall give your son a substance-free environment, accountability, and a community of men on the same path.',
    ],
    whoFor: [
      'Parents searching for recovery housing for a son',
      'Family members supporting a man in recovery',
      'Loved ones helping arrange a stable next step',
      'Anyone helping a man find men’s recovery housing',
    ],
    sections: [
      { h: 'How you can help your son take the next step', p: [
        'You can call us with your questions, help your son complete an application, or ask us to reach out to him directly. We’ll explain what our homes are like, current availability, and how the process works.',
        'The decision to enter recovery housing ultimately belongs to your son, but families play a huge role in helping it happen.',
      ] },
      { h: 'Men’s homes designed for recovery', p: [
        'Our Whitehall home are dedicated men’s recovery housing — substance-free, structured, and built on peer accountability.',
        'Explore the men’s hub and city pages, or reach out and we’ll help you find the right fit.',
      ] },
    ],
    faqs: [
      { q: 'Can I apply on my son’s behalf?', a: 'You can help him apply and call us with questions. The commitment to recovery housing needs to be his, but families are a vital part of the process.' },
      { q: 'Where are the men’s homes?', a: 'In Whitehall, PA (855 3rd Street), in the Lehigh Valley.' },
      { q: 'Is this treatment?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'Can funding help with cost?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; approval is not guaranteed.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-housing-for-my-daughter/',
    category: 'Family Search Intent', tier: 'Tier 7', gender: 'women',
    name: 'Recovery Housing for My Daughter',
    primaryKeyword: 'Recovery Housing for My Daughter',
    keywords: ['sober living for my daughter', 'recovery home for my daughter', 'help my daughter find sober living'],
    title: 'Recovery Housing for My Daughter | PGSRH Lehigh Valley, PA',
    description: 'Searching for recovery housing for your daughter? PGSRH offers a safe, structured women’s home in Catasauqua, PA. Compassionate help for families. Contact us.',
    blurb: 'For parents and families searching on behalf of a daughter.',
    heroSubtitle: 'If you’re searching for a safe place for your daughter, we understand — and we’re here to help you find structured women’s recovery housing.',
    intro: [
      'A parent searching for “recovery housing for my daughter” is often carrying a lot of fear and hope at once. PGSRH provides a safe, structured women’s recovery home in the Lehigh Valley, and we’re glad to help you understand the options.',
      'Our Catasauqua home gives your daughter a substance-free environment, safety, and a community of women on the same path.',
    ],
    whoFor: [
      'Parents searching for recovery housing for a daughter',
      'Family members supporting a woman in recovery',
      'Loved ones helping arrange a stable next step',
      'Anyone helping a woman find women’s recovery housing',
    ],
    sections: [
      { h: 'How you can help your daughter take the next step', p: [
        'You can call us with your questions, help your daughter complete an application, or ask us to reach out to her directly. We’ll explain what our home is like, current availability, and how the process works.',
        'The decision to enter recovery housing ultimately belongs to your daughter, but families play a huge role in helping it happen.',
      ] },
      { h: 'A women’s home built for safety and support', p: [
        'Our Catasauqua home is dedicated women’s recovery housing — substance-free, structured, and built around safety and peer support.',
        'Explore the women’s hub and Catasauqua page, or reach out and we’ll help you find the right fit.',
      ] },
    ],
    faqs: [
      { q: 'Can I apply on my daughter’s behalf?', a: 'You can help her apply and call us with questions. The commitment to recovery housing needs to be hers, but families are a vital part of the process.' },
      { q: 'Where is the women’s home?', a: 'At 425 Walnut Street, Catasauqua, PA 18032, in the Lehigh Valley.' },
      { q: 'Is this treatment?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'Can funding help with cost?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; approval is not guaranteed.' },
    ],
    funding: true,
  },
  {
    slug: '/safe-recovery-housing/',
    category: 'Family Search Intent', tier: 'Tier 7',
    name: 'Safe Recovery Housing',
    primaryKeyword: 'Safe Recovery Housing',
    keywords: ['safe sober living', 'safe recovery house', 'safe sober housing'],
    title: 'Safe Recovery Housing in the Lehigh Valley, PA | PGSRH',
    description: 'Looking for safe recovery housing? PGSRH homes are substance-free, structured, and built on clear expectations and peer support in the Lehigh Valley, PA. Learn more.',
    blurb: 'What makes recovery housing safe and structured.',
    heroSubtitle: 'Safety comes from structure, expectations, and community — here’s how PGSRH homes create a safe environment.',
    intro: [
      'Families and individuals often search specifically for “safe” recovery housing — and for good reason. A safe home is the foundation everything else in recovery is built on.',
      'This page explains, honestly, what contributes to a safe recovery housing environment at PGSRH.',
    ],
    whoFor: [
      'Families prioritizing safety for a loved one',
      'Individuals who want a secure, stable home',
      'People who’ve had bad experiences elsewhere',
      'Anyone comparing homes on safety',
    ],
    sections: [
      { h: 'What makes a home safe', p: [
        'Safety comes from a substance-free environment, clear expectations everyone follows, accountable peers, and a structured routine. Together these reduce chaos and create a dependable place to live.',
        'We describe our environment honestly and avoid promises no home can truthfully make.',
      ] },
      { h: 'Safety at PGSRH', p: [
        'Our homes maintain substance-free standards and shared expectations designed to keep residents supported. We’re happy to answer specific questions about how our homes operate.',
        'Contact us and we’ll walk you through what to expect.',
      ] },
    ],
    faqs: [
      { q: 'What makes recovery housing safe?', a: 'A substance-free environment, clear expectations, accountable peers, and a structured routine all contribute to a safe home.' },
      { q: 'Can you guarantee my loved one’s safety?', a: 'No home can guarantee outcomes, but we maintain substance-free standards and clear expectations designed to support residents. We’ll answer your specific questions honestly.' },
      { q: 'Are men and women housed separately?', a: 'Yes. PGSRH offers separate men’s and women’s homes.' },
      { q: 'How do I learn more about your standards?', a: 'Contact PGSRH and we’ll explain how our homes operate and what expectations apply.' },
    ],
    funding: false,
  },
  {
    slug: '/recovery-housing-for-adults/',
    category: 'Family Search Intent', tier: 'Tier 7',
    name: 'Recovery Housing for Adults',
    primaryKeyword: 'Recovery Housing for Adults',
    keywords: ['sober living for adults', 'adult recovery housing', 'adult recovery home'],
    title: 'Recovery Housing for Adults | PGSRH Lehigh Valley, PA',
    description: 'PGSRH provides recovery housing for adult men and women in the Lehigh Valley, PA — structured, sober homes with peer support. Learn who qualifies and how to apply.',
    blurb: 'Structured recovery housing for adult men and women.',
    heroSubtitle: 'Structured, sober recovery housing for adults — men’s and women’s homes across the Lehigh Valley.',
    intro: [
      'PGSRH recovery housing serves adults in recovery — men and women who are ready for a structured, substance-free home and a supportive community.',
      'This page is for anyone searching by age group or wanting to confirm that our homes are for adults.',
    ],
    whoFor: [
      'Adults in recovery seeking a sober home',
      'Families searching for adult recovery housing',
      'People confirming eligibility by age',
      'Referral partners placing adult clients',
    ],
    sections: [
      { h: 'Who our homes serve', p: [
        'Our homes are for adults committed to a substance-free lifestyle and willing to follow house expectations. We offer separate men’s and women’s residences in the Lehigh Valley.',
        'If you’re not sure whether our homes fit your situation, just ask — we’ll give you a straight answer.',
      ] },
      { h: 'Finding the right home', p: [
        'Choose between men’s and women’s housing, then compare locations to stay close to your support network.',
        'Contact us to learn about availability and next steps.',
      ] },
    ],
    faqs: [
      { q: 'Is PGSRH recovery housing for adults?', a: 'Yes. Our homes serve adult men and women in recovery who are committed to a substance-free lifestyle and house expectations.' },
      { q: 'Do you have men’s and women’s homes?', a: 'Yes. The men’s home is in Whitehall; a women’s home is in Catasauqua.' },
      { q: 'Is this treatment?', a: 'No. It is structured, sober housing with peer support, not clinical treatment.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about availability.' },
    ],
    funding: false,
  },
  {
    slug: '/affordable-recovery-housing/',
    category: 'Family Search Intent', tier: 'Tier 7',
    name: 'Affordable Recovery Housing',
    primaryKeyword: 'Affordable Recovery Housing',
    keywords: ['affordable sober living', 'affordable recovery homes', 'low cost recovery housing', 'recovery housing scholarships'],
    title: 'Affordable Recovery Housing & Funding Options | PGSRH',
    description: 'Worried about cost? Learn about affordable recovery housing and funding or scholarship options that may be available at PGSRH in the Lehigh Valley, PA. Ask what applies.',
    blurb: 'Affordability, scholarships, and how to ask about options.',
    heroSubtitle: 'Cost shouldn’t be the only thing standing between someone and stable recovery housing — here’s how to ask about options.',
    intro: [
      'For many families, cost is the biggest worry when looking at recovery housing. This page explains how to think about affordability and how to ask PGSRH about funding or scholarship options that may apply.',
      'We keep the conversation honest: we won’t promise free housing or guaranteed approval, but we’ll help you understand what may be possible.',
    ],
    whoFor: [
      'Families worried about the cost of recovery housing',
      'Individuals on a tight budget seeking a sober home',
      'People searching for scholarships or payment assistance',
      'Anyone who needs to understand affordability before applying',
    ],
    sections: [
      { h: 'Thinking about affordability', p: [
        'Recovery housing has a cost, like any housing. But cost can sometimes be offset. Depending on eligibility and availability, funding or scholarship options may help make a stay more manageable.',
        'The best first step is a direct conversation with us about your situation and current options.',
      ] },
      { h: 'How to ask about options', p: [
        'County, state, scholarship, and assistance programs each have their own requirements, and availability changes. PGSRH can discuss current payment and referral options and explain what may apply.',
        'Visit our funding hub for a full overview, or contact us to ask directly.',
      ] },
    ],
    faqs: [
      { q: 'Is there free recovery housing?', a: 'We don’t promise free housing. Depending on eligibility and availability, funding or scholarship options may help with cost. Ask PGSRH what may apply.' },
      { q: 'What funding options might be available?', a: 'County, state, scholarship, and other assistance programs may be available, each with their own requirements. Availability must be confirmed and approval is not guaranteed.' },
      { q: 'How do I ask about affordability?', a: 'Contact PGSRH directly. We’ll discuss current payment and referral options and what may apply to your situation.' },
      { q: 'Where can I learn more about funding?', a: 'Visit our recovery housing funding & scholarship assistance hub for a full overview.' },
    ],
    funding: true,
  },
  {
    slug: '/family-guide-recovery-housing/',
    category: 'Family Search Intent', tier: 'Tier 7',
    name: 'Family Guide to Recovery Housing',
    primaryKeyword: 'Family Guide to Recovery Housing',
    keywords: ['recovery housing guide for families', 'sober living guide for parents'],
    title: 'A Family Guide to Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'A compassionate, practical family guide to recovery housing — how it works, how to help a loved one, and how to ask about funding. From PGSRH in the Lehigh Valley, PA.',
    blurb: 'A compassionate, practical guide for families.',
    heroSubtitle: 'A compassionate, practical guide for families trying to understand recovery housing and help someone they love.',
    intro: [
      'When someone you love is in recovery, it’s hard to know how to help. This guide is written for families — to explain what recovery housing is, how it helps, and what your role can be.',
      'We’ll keep it honest and practical, including how to think about cost and funding.',
    ],
    whoFor: [
      'Parents, partners, and family members of someone in recovery',
      'Families new to the idea of recovery housing',
      'Loved ones unsure how to help',
      'Anyone supporting a family member’s next step',
    ],
    sections: [
      { h: 'Understanding recovery housing as a family', p: [
        'Recovery housing is a safe, structured, substance-free home with peer support — not treatment. For families, it often provides relief: a stable environment where a loved one can rebuild routine and accountability.',
        'Your encouragement and involvement can make a real difference, even though the commitment must come from your loved one.',
      ] },
      { h: 'Helping a loved one — including with cost', p: [
        'You can help by learning the options, supporting the application, and staying connected. If cost is a concern, funding or scholarship options may be available depending on eligibility and availability.',
        'See our page on helping a loved one find recovery housing, and reach out with your questions anytime.',
      ] },
    ],
    faqs: [
      { q: 'How can my family help a loved one?', a: 'Learn the options, support the application, stay connected, and encourage the commitment — which ultimately must come from your loved one.' },
      { q: 'Is recovery housing treatment?', a: 'No. It is a supportive place to live, not clinical treatment. PGSRH does not provide medical services.' },
      { q: 'How do we handle the cost as a family?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; approval is not guaranteed.' },
      { q: 'What’s the first step?', a: 'Contact PGSRH with your questions. We’ll walk you through the options with compassion and honesty.' },
    ],
    funding: true,
  },
  {
    slug: '/help-loved-one-find-recovery-housing/',
    category: 'Family Search Intent', tier: 'Tier 7',
    name: 'Help a Loved One Find Recovery Housing',
    primaryKeyword: 'Help a Loved One Find Recovery Housing',
    keywords: ['find recovery housing for loved one', 'help someone find sober living'],
    title: 'Help a Loved One Find Recovery Housing | PGSRH',
    description: 'Want to help a loved one find recovery housing? PGSRH makes it simple — call, apply on their behalf, or ask us to reach out. Compassionate support in the Lehigh Valley, PA.',
    blurb: 'Simple, compassionate steps to help someone you love.',
    heroSubtitle: 'Simple, compassionate steps to help someone you love find safe, structured recovery housing.',
    intro: [
      'Helping a loved one find recovery housing can feel overwhelming, but the path is simpler than it looks. PGSRH is here to help you take the next step for someone you care about, in the Lehigh Valley.',
      'Whether they’re coming from treatment, detox, or an unstable situation, we can talk through the options with you.',
    ],
    whoFor: [
      'Family members ready to take action for a loved one',
      'Friends supporting someone in recovery',
      'People helping arrange housing after treatment or detox',
      'Anyone who needs a clear next step',
    ],
    sections: [
      { h: 'Three ways to help right now', p: [
        'You can call us with questions, help your loved one complete our online application, or ask us to reach out to them directly. Whichever fits your situation, we’ll meet you where you are.',
        'We’ll explain what our homes are like, current availability, and how the process works.',
      ] },
      { h: 'A compassionate, direct next step', p: [
        'The most important thing is to take a step. Even a phone call to ask questions moves things forward and can bring real relief.',
        'If cost is a worry, funding or scholarship options may be available depending on eligibility and availability — ask us what may apply.',
      ] },
    ],
    faqs: [
      { q: 'Can I contact you on behalf of my loved one?', a: 'Yes. You can call us, apply on their behalf, or ask us to reach out to them directly.' },
      { q: 'What if my loved one is unsure?', a: 'That’s common. Start by calling us with questions — we can talk through options and help you figure out the best approach.' },
      { q: 'Do you have men’s and women’s homes?', a: 'Yes. The men’s home is in Whitehall; a women’s home is in Catasauqua.' },
      { q: 'Can funding help with cost?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; approval is not guaranteed.' },
    ],
    funding: true,
  },
];

export default pages;
